import disableConsoleLogging from './Helpers/disableConsoleLogging';

disableConsoleLogging();

import React from 'react';
import ReactDOM from 'react-dom/client';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";
const browserHistory = createBrowserHistory();

import { SignInStateProvider } from './Components/signInState';
import { AuthProvider } from './context/AuthContext';
import { ConfigProvider } from './context/ConfigContext';
import App from './App';

import './index.css';
import './utils/sleek';

if (process.env.REACT_APP_MS_APPLICATION_INSIGHTS) {
  const reactPlugin = new ReactPlugin();
  const clickPluginInstance = new ClickAnalyticsPlugin();
  const clickPluginConfig = {
    autoCapture: true
  };
  const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.REACT_APP_MS_APPLICATION_INSIGHTS,
        extensions: [reactPlugin, clickPluginInstance],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory },
          [clickPluginInstance.identifier]: clickPluginConfig
        }
    }
  });
  appInsights.loadAppInsights();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <AuthProvider>
        <SignInStateProvider>
            <App />
        </SignInStateProvider>
      </AuthProvider>
    </ConfigProvider>
  </React.StrictMode>
);
